//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import TransitionExpand from './global/TransitionExpand';
    export default {
        components: {
            appTransitionExpand: TransitionExpand
        },
        data: function () {
            return {
                loaded: false,
                mobileOpen: false,
                filterState: []
            }
        },
        watch: {
            filters() {
                let filterState = [];
                this.filters.forEach(() => {
                    filterState.push(true);
                });
                this.filterState = filterState;

                if (!this.loaded && this.$route.query.c && this.filters.length > 0) {
                    var f = JSON.parse(JSON.stringify(this.filters));
                    this.updateFiltersFromQuerystring(this.$route.query.c, f);

                    this.$emit('submitFilters', f);
                     this.loaded = true;
                }
            }
        },
        computed: {
            filters: function () {
                return this.$store.state.results.filters;
            },
            settings: function () {
                return this.$store.state.settings;
            },
            visibleFilters: function() {
                return this.filters.filter(f => f.visible == true);
            }


        },
        methods: {
            toggleFilter(e, i) {
                const filterState = [...this.filterState];
                filterState[i] = !filterState[i];
                this.filterState = filterState;
            },
            submitFilters: function () {
                this.$emit('submitFilters', this.filters);
            },
            updateFiltersFromQuerystring(query, filters) {
                var ids = query.split(',');

                ids.forEach(function (theID) {

                    filters.forEach(function (parent) {
                        var match = parent.filters.find(c => c.id === theID);

                        if (match) {
                            match.selected = true;
                        }
                    });
                });
            },
            getFilterText: function(filter) {
                return filter.value + " (" + filter.count + ")";
            }
        },
        mounted() {
            let filterState = [];
            this.filters.forEach(filterGroup => {
                filterState.push(true);
            });
            this.filterState = filterState;
        }
    }
